import React, { useState } from 'react';
import { CheckCircle2, Lock, Zap, CreditCard, Star } from 'lucide-react';
import { motion } from 'framer-motion';
type PlanId = 'basico' | 'completo';
interface Plan {
  id: PlanId;
  name: string;
  desc: string;
  oldPrice: string;
  price: string;
  url: string;
  save?: string;
  recommended?: boolean;
}
const plans: Plan[] = [{
  id: 'basico',
  name: 'KIT EPILEPSIA BAJO CONTROL™ 2026',
  desc: '4 Tomos + 3 Bonos',
  oldPrice: '$38.990',
  price: '$19.990',
  url: 'https://www.nexorecursos.com/cart/52650829185300:1'
}, {
  id: 'completo',
  name: 'KIT COMPLETO',
  desc: '4 Tomos + 3 Bonos + KIT EPILEPSIA BAJO CONTROL PRO™',
  oldPrice: '$43.990',
  price: '$24.990',
  url: 'https://www.nexorecursos.com/cart/52650831053076:1',
  save: 'AHORRÁS $18.000',
  recommended: true
}];
export const OfferSelector = () => {
  const [selected, setSelected] = useState<PlanId>('completo');
  const selectedPlan = plans.find(p => p.id === selected)!;
  const handleBuy = () => {
    window.location.href = selectedPlan.url;
  };
  return <div className="max-w-2xl mx-auto" data-id="element-187">
      <div className="grid grid-cols-2 gap-2.5 sm:gap-3 pt-3" data-id="element-188">
        {plans.map(plan => {
        const isSelected = selected === plan.id;
        const isCompleto = plan.id === 'completo';
        return <button key={plan.id} type="button" onClick={() => setSelected(plan.id)} aria-pressed={isSelected} className={`relative text-left rounded-xl p-3 sm:p-4 transition-all duration-200 border-2 focus:outline-none focus:ring-2 focus:ring-brand-orange/50 ${isSelected ? isCompleto ? 'border-brand-gold bg-white shadow-lg ring-2 ring-brand-gold/40 scale-[1.03]' : 'border-brand-orange bg-white shadow-lg ring-1 ring-brand-orange/30' : 'border-gray-200 bg-white/70 hover:border-brand-orange/40'} ${plan.recommended ? 'scale-[1.02]' : ''}`} data-id="element-189">
              {plan.recommended && <div className="absolute -top-2.5 left-1/2 -translate-x-1/2 bg-brand-gold text-white font-bold px-2.5 py-0.5 rounded-full text-xs sm:text-sm shadow-md flex items-center gap-1 w-max" data-id="element-190">
                  <Star size={12} className="fill-white" data-id="element-191" /> MÁS ELEGIDO
                </div>}

              {/* Radio + title */}
              <div className="flex items-start gap-2 mb-1.5" data-id="element-192">
                <span className={`mt-0.5 flex-shrink-0 w-4 h-4 rounded-full border-2 flex items-center justify-center transition-colors ${isSelected ? isCompleto ? 'border-brand-gold bg-brand-gold' : 'border-brand-orange bg-brand-orange' : 'border-gray-300'}`} data-id="element-193">
                  {isSelected && <span className="w-1.5 h-1.5 rounded-full bg-white" data-id="element-194" />}
                </span>
                <div className="min-w-0" data-id="element-195">
                  <h3 className="font-heading font-bold text-gray-900 leading-tight text-sm sm:text-base" data-id="element-196">
                    {plan.name}
                  </h3>
                  <p className="text-gray-500 text-[11px] leading-snug mt-0.5" data-id="element-197">
                    {plan.desc}
                  </p>
                </div>
              </div>

              {plan.save && <div className="ml-6 inline-block bg-brand-green/10 text-brand-green text-[10px] font-bold px-2 py-0.5 rounded-full mb-1" data-id="element-198">
                  {plan.save}
                </div>}

              <div className="ml-6 flex items-baseline gap-1.5 flex-wrap" data-id="element-199">
                <span className="text-xl sm:text-2xl font-heading font-extrabold text-gray-900" data-id="element-200">
                  {plan.price}
                </span>
                <span className="text-gray-400 line-through text-xs" data-id="element-201">
                  {plan.oldPrice}
                </span>
              </div>
            </button>;
      })}
      </div>

      {/* Shared buy button */}
      <motion.button onClick={handleBuy} whileTap={{
      scale: 0.98
    }} className="w-full mt-4 bg-brand-orange hover:bg-brand-orange/90 text-white font-bold text-base sm:text-lg px-6 py-3.5 rounded-xl shadow-soft transform transition hover:-translate-y-0.5 flex items-center justify-center gap-1.5 text-center" data-id="element-202">
        {selected === 'completo' ? '✅ SÍ, QUIERO EL KIT COMPLETO' : '💥 QUIERO MI KIT EPILEPSIA BAJO CONTROL AHORA'}
        <span className="font-extrabold" data-id="element-203">— {selectedPlan.price}</span>
      </motion.button>

      {/* Trust Row */}
      <div className="mt-3.5 flex flex-wrap justify-center items-center gap-x-4 gap-y-1.5 text-xs sm:text-sm text-gray-600 font-medium" data-id="element-204">
        <span className="flex items-center gap-1.5" data-id="element-205">
          <Lock size={16} className="text-gray-400" data-id="element-206" /> Pago seguro
        </span>
        <span className="flex items-center gap-1.5" data-id="element-207">
          <Zap size={16} className="text-brand-amber" data-id="element-208" /> Acceso en 5 min
        </span>
        <span className="flex items-center gap-1.5" data-id="element-209">
          <CheckCircle2 size={16} className="text-green-600" data-id="element-210" /> Garantía 7 días
        </span>
        <span className="flex items-center gap-1.5" data-id="element-211">
          <CreditCard size={16} className="text-blue-500" data-id="element-212" /> Mercado Pago
        </span>
      </div>
    </div>;
};